import { render, staticRenderFns } from "./PurchaseCallback.vue?vue&type=template&id=2459cfc5&scoped=true&"
import script from "./PurchaseCallback.vue?vue&type=script&lang=js&"
export * from "./PurchaseCallback.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCallback.vue?vue&type=style&index=0&id=2459cfc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2459cfc5",
  null
  
)

export default component.exports